import React, { Component } from "react";
import { PageHeader } from "antd";
import { connect } from "react-redux";
import { FileProtectOutlined, HistoryOutlined, TeamOutlined } from "@ant-design/icons";
import TabbedDynamicTable from "../../../Components/TabbedDynamicTable";
import BotonAyudaManuales from "../../../Components/BotonAyudaManuales";
import AvisoIa from "./AvisoIa";
import UsuariosIa from "./UsuariosIa";
import BitacoraIa from "./BitacoraIa";

class IA extends Component {
  state = {
    tab: this.props.permisoAccesoEmpresasIa ? "aviso" : this.props.permisoAccesoUsuariosIa ? "usuarios" : "bitacora",
  };

  render() {
    const tabs = [
      this.props.permisoAccesoEmpresasIa && {
        key: "aviso",
        label: (
          <span>
            <FileProtectOutlined /> Empresas y aviso
          </span>
        ),
        customContent: <AvisoIa activo={this.state.tab === "aviso"} />,
      },
      this.props.permisoAccesoUsuariosIa && {
        key: "usuarios",
        label: (
          <span>
            <TeamOutlined /> Usuarios
          </span>
        ),
        customContent: <UsuariosIa activo={this.state.tab === "usuarios"} />,
      },
      this.props.permisoAccesoBitacoraIa && {
        key: "bitacora",
        label: (
          <span>
            <HistoryOutlined /> Bitácora
          </span>
        ),
        customContent: <BitacoraIa activo={this.state.tab === "bitacora"} />,
      },
    ].filter(Boolean);

    return (
      <>
        <PageHeader
          title="IA"
          subTitle="Acceso de tus usuarios a asistentes de IA"
          extra={[<BotonAyudaManuales key="manuales" modulo="iaAdministrador" />]}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div style={{ backgroundColor: "white", padding: 20, paddingTop: 10, borderRadius: 12, border: "1px solid rgb(235, 237, 240)" }}>
          <TabbedDynamicTable tabs={tabs} defaultActiveKey={this.state.tab}onTabChange={(tab) => this.setState({ tab })} />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisoAccesoEmpresasIa:
      state.user.tipo === 0 ||
      state.user.permisos.find((p) => p.permisoId.toString() === "6ad3a5cd2857d5048c4b38c4")?.activado,
    permisoAccesoUsuariosIa:
      state.user.tipo === 0 ||
      state.user.permisos.find((p) => p.permisoId.toString() === "6ad3a5dd2857d5048c4b38c5")?.activado,
    permisoAccesoBitacoraIa:
      state.user.tipo === 0 ||
      state.user.permisos.find((p) => p.permisoId.toString() === "6ad3a5e934886b04b07905e7")?.activado,
  };
};

export default connect(mapStateToProps)(IA);
